import {PlatformReportingFilterType} from "../ReportingFilterType";
import BaseFilter from "../BaseFilter";
import {action} from "mobx";
import {ReportVerticalType} from '../../../enums/ReportVerticalType';
import {alias, define, inject, singleton} from '@injex/core';
import AccountsMetaDataManager from '../../../managers/AccountsMetaDataManager.mdl';

@define()
@singleton()
@alias('PlatformReportingFilter')
export default class UserFilter extends BaseFilter {

	public type = PlatformReportingFilterType.User;
    @inject() public accountsMetaDataManager: AccountsMetaDataManager;

	constructor() {
		super();

		this.allowNew = false;
		this.labelKey = "username";
		this.valueKey = "_id";
	}

	public initialize(): Promise<any> {
		this.setData();
		// Shared links restore users by ID, so wait until the accounts list has loaded.
		return this.accountsMetaDataManager.whenReady().then(() => this.setData());
	}

	private setData() {
		this.items = this.accountsMetaDataManager.accountsByVertical[ReportVerticalType.PLATFORM];
		this.isLoading = false;
	}
}
